import { render, staticRenderFns } from "./CertificateBlank.vue?vue&type=template&id=6df4ab60&scoped=true&"
import script from "./CertificateBlank.vue?vue&type=script&lang=js&"
export * from "./CertificateBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df4ab60",
  null
  
)

export default component.exports